<template>
    <div v-if="mostrarMenu">
        <h4 class="heading-1">
            <span>SGF</span>
        </h4>
        <b-list-group>
            <relacao-contratacoes-entregas></relacao-contratacoes-entregas>
            <relacao-reabertura-entregas></relacao-reabertura-entregas>
            <relacao-cancelamento-entregas></relacao-cancelamento-entregas>
            <relacao-contratacoes-entregas-gestor></relacao-contratacoes-entregas-gestor>
            <relacao-contratacoes-entregas-gerente></relacao-contratacoes-entregas-gerente>
        </b-list-group>
    </div>
</template>

<script>
import RelacaoContratacoesEntregas from '../uabs/relatorios/RelacaoContratacoesEntregas'
import RelacaoReaberturaEntregas from '../uabs/relatorios/RelacaoReaberturaEntregas'
import RelacaoCancelamentoEntregas from '../uabs/relatorios/RelacaoCancelamentoEntregas'
import RelacaoContratacoesEntregasGestor from '../gestores/relatorios/RelacaoContratacoesEntregasGestor'
import RelacaoContratacoesEntregasGerente from '../gerentes/relatorios/RelacaoContratacoesEntregasGerente'

export default {
    components: {
        RelacaoContratacoesEntregas,
        RelacaoContratacoesEntregasGestor,
        RelacaoContratacoesEntregasGerente,
        RelacaoReaberturaEntregas,
        RelacaoCancelamentoEntregas
    },

    props: {
        servicos: {
            type: Object
        }
    },

    computed: {
        mostrarMenu() {
            return this.$temAcessoView('CRED-REL-00')
        }
    }
}
</script>
